import { render } from "./BaoCaoKetQuaKiemTraVSNuocSachDaGoi.vue?vue&type=template&id=4167c6dc&ts=true"
import script from "./BaoCaoKetQuaKiemTraVSNuocSachDaGoi.vue?vue&type=script&lang=ts"
export * from "./BaoCaoKetQuaKiemTraVSNuocSachDaGoi.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__